import React, { useContext, useState } from 'react';
import AntButton, { ButtonProps as AntButtonProps } from 'antd/lib/button';
import RouterLink from './RouterLink';
import useComponentConfiguration from 'DisplayFramework/useComponentConfiguration';
import { AuthContext } from './Auth/Auth';
import { Input, notification } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import {
  ParPagComponentRequest,
  updatePageComponent,
} from 'services/displayFramework';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';

export type ButtonProps = Omit<AntButtonProps, 'children'> & {
  to?: string;
  comcode: string;
  disabled?: boolean;
  Inspectstyle?: React.CSSProperties;
  custom?: React.CSSProperties;
};

const ButtonOperation = ({
  disabled,
  comcode,
  Inspectstyle,
  custom,
  ...otherProps
}: ButtonProps) => {
  const { isHidden, label, style } = useComponentConfiguration(comcode);
  const { pagcode, refresh } = useDisplayFrameworkContext();
  const { isInspect } = useContext(AuthContext);
  const [newLabel, setNewLabel] = useState('');

  if (isHidden) {
    return null;
  }

  const handleSaveNewLabel = (comcode: string, labelp: string) => {
    const request: ParPagComponentRequest = {
      comcode: comcode ?? '',
      comformat: '',
      comhint: '',
      comlabel: newLabel === '' ? label : labelp,
      commessage: '',
      complaceholder: '',
      comrequired: false,
      comstyle: '',
      comtype: '',
      pagcode: pagcode ?? '',
    };
    updatePageComponent({ request: request }).then((res) => {
      if (res.code === '200')
        notification.success({
          message: res.message,
          description: res.description,
        });
      else {
        notification.error({
          message: res.message,
          description: res.description,
        });
      }
      refresh();
    });
  };

  const props = {
    ...otherProps,
    children: isInspect ? (
      <Input
        defaultValue={label === '' ? comcode : label}
        size="middle"
        onChange={(event) => {
          event.preventDefault();
          setNewLabel(event.target.value);
        }}
        onClick={(event) => {
          event.preventDefault();
        }}
        style={Inspectstyle ?? { width: '80%' }}
        className="input-inspect"
        addonAfter={
          <SaveOutlined
            onClick={(ev) => {
              ev.preventDefault();
              handleSaveNewLabel(comcode, newLabel);
            }}
          />
        }
      />
    ) : (
      label
    ),
    style,
  };

  if (props.to) {
    return <RouterLink disabled={disabled} component={AntButton} {...props} />;
  } else {
    return (
      <AntButton
        disabled={disabled}
        {...props}
        style={
          custom
            ? {
                width: custom?.width,
                height: custom?.height ?? 35,
                backgroundColor: custom?.backgroundColor ?? 'white',
                ...custom,
              }
            : { height: 35 }
        }
      />
    );
  }
};

export default ButtonOperation;
